import {
    FieldInCard,
} from 'app/types/form.types'
import {
    LoggerExchangeNote,
} from '../../../ContainerNotes.types'
import {
    AuditTrailConfig, getChangeConfig,
} from './notesConfigs'

type Fields = keyof LoggerExchangeNote

const fields: FieldInCard<Fields>[] = [
    getChangeConfig(),
    {
        title: 'Loggers',
        className: 'logger',
        fields: [{
            name: 'loggerChange',
            componentName: 'LoggerSelector',
        }],
    },
    AuditTrailConfig,
]

export default fields
